import React from 'react';

import { FormErrorType } from '../../services/forms/FormHelpers';

interface IProps {
  isMultiFile?: boolean;
  formData: any;
  setFormData: (prev: any) => void;
  errors: FormErrorType;
  label?: string;
  disabled?: boolean;
  accept?: string;
}

export const ZeosFileUpload = (props: IProps) => {
  const { label = "Upload File", accept = "image/*" } = props;
  const handleFileChange = (files: FileList | null) => {
    if (files) {
      props.setFormData((prev: any) => ({
        ...prev,
        file: Array.from(files),
      }));
    }
  };

  return (
    <div>
      <label className="cursor-pointer px-4 py-2 bg-zeos-blue text-white rounded">
        {props.formData.file?.length ? props.formData.file[0].name : label}
        <input
          type="file"
          accept={accept}
          multiple={props.isMultiFile}
          onChange={(e) => handleFileChange(e.target.files)}
          disabled={props.disabled}
          hidden
        />
      </label>
      {props.errors.file && (
        <p className="mt-1 text-xs text-zeos-orange-dk">{props.errors.file}</p>
      )}
    </div>
  );
};
